import React, { useContext } from 'react';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { useQAResult } from '../QAResult/useQAResult';
import QAContext from '../../context/QAContext';
import { dataModel } from '../dataModel';
import '../QAResult/QAResult.scss';

const AccordionTitleComponent = () => {
  const { TotalResults, qaLoading } = useContext(QAContext);

  useQAResult();

  if (qaLoading) {
    return (
      <Placeholder
        type="rect"
        height="50px"
        width="100%"
      />
    );
  }

  return (
    <div className="qa-result__accordion">
      <h3 className="qa-result__accordion-header">
        Questions &amp; Answers
      </h3>
      {TotalResults > 0
        && (
          <div className="qa-result__accordion-subheader">
            <span className="">{ TotalResults } { TotalResults === 1 ? 'Question' : 'Questions' }</span>
          </div>
        )}
    </div>
  );
};

AccordionTitleComponent.displayName = 'QuestionsAnswersAccordionTitle';

AccordionTitleComponent.propTypes = {};

AccordionTitleComponent.defaultProps = {};

AccordionTitleComponent.dataModel = dataModel;

export { AccordionTitleComponent };